export interface Tprovinsi {
    id?: number;
    provCode: string;
    provinsiName: string;
    sniCode: string;
    intlCode: string;
}

export const initialProvinsi: Tprovinsi = {
    provCode: "",
    provinsiName: "",
    sniCode: "",
    intlCode: ""
}